var $ = require('jquery');

(function () {
    var LagPopover = function (element, options) {
        this.init('lagPopover', element, options)
    };

    LagPopover.HOVER_CLOSE = '__hoverClose';

    LagPopover.DEFAULTS = $.extend({}, $.fn.popover.Constructor.DEFAULTS, {
        trigger: 'hover',
        delay: {
            show:0,
            hide:100
        },
        template: '<div class="lag-popover popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    });

    LagPopover.prototype = $.extend({}, $.fn.popover.Constructor.prototype);

    LagPopover.prototype.constructor = LagPopover;

    LagPopover.prototype.getDefaults = function () {
        return LagPopover.DEFAULTS
    };

    LagPopover.prototype.setContent = function () {
        var $tip    = this.tip();
        var title   = this.getTitle();
        var content = this.getContent();
        var self = this;
        var popoverContent = $tip.find('.popover-content').children().detach().end();

        $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title);

        if(content && $.type(content.then)==='function'){
            setContent('内容加载中……');
            Promise.resolve(content).then(function (content) {
                setContent(content);
            },function () {
                setContent('加载内容出错');
            })['finally'](function () {
                self.reposition();
            });
        }else{
            setContent(content)
        }
        function setContent(content) {
            popoverContent[ // we use append for html objects to maintain js events
                self.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
                ](content);
        }

        $tip.toggleClass(LagPopover.HOVER_CLOSE,this.options.trigger.indexOf('hover')!==-1);

        $tip.removeClass('fade top bottom left right in');

        // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
        // this manually by checking the contents.
        if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
    };

    LagPopover.prototype.enter = function (obj) {
        var self = obj instanceof this.constructor ?
            obj : $(obj.currentTarget).data('bs.' + this.type);

        if (!self) {
            self = new this.constructor(obj.currentTarget, this.getDelegateOptions());
            $(obj.currentTarget).data('bs.' + this.type, self)
        }

        if (obj instanceof $.Event) {
            self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
        }

        if (self.tip().hasClass('in') || self.hoverState == 'in') {
            self.hoverState = 'in';
            return
        }

        clearTimeout(self.timeout);

        self.hoverState = 'in';

        self.tip().data('bs.lagPopover.rel',self);//赋值给弹窗元素

        if (!self.options.delay || !self.options.delay.show) return self.show();

        self.timeout = setTimeout(function () {
            if (self.hoverState == 'in') self.show()
        }, self.options.delay.show)
    };

    LagPopover.prototype.reposition = function () {
        var $tip = this.tip();

        var placement = typeof this.options.placement == 'function' ?
            this.options.placement.call(this, $tip[0], this.$element[0]) :
            this.options.placement;

        var autoToken = /\s?auto?\s?/i;
        var autoPlace = autoToken.test(placement);
        if (autoPlace) placement = placement.replace(autoToken, '') || 'top';

        $tip
            .detach()
            .css({ top: 0, left: 0, display: 'block' })
            .addClass(placement)
            .data('bs.' + this.type, this);

        this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element);
        this.$element.trigger('inserted.bs.' + this.type);

        var pos          = this.getPosition();
        var actualWidth  = $tip[0].offsetWidth;
        var actualHeight = $tip[0].offsetHeight;

        if (autoPlace) {
            var orgPlacement = placement;
            var viewportDim = this.getPosition(this.$viewport);

            placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                        placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                            placement;

            $tip
                .removeClass(orgPlacement)
                .addClass(placement)
        }

        var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight);

        this.applyPlacement(calculatedOffset, placement);
    };

    function Plugin(option) {
        return this.each(function () {
            var $this   = $(this);
            var data    = $this.data('bs.lagPopover');
            var options = typeof option == 'object' && option;

            if (!data && /destroy|hide/.test(option)) return;
            if (!data) $this.data('bs.lagPopover', (data = new LagPopover(this, options)));
            if (typeof option == 'string') data[option]();
        })
    }

    $.fn.lagPopover             = Plugin;
    $.fn.lagPopover.Constructor = LagPopover;

    $(document).on('mouseenter.bs.lagPopover', '.'+LagPopover.HOVER_CLOSE, function () {
        var lagPopover = $(this).data('bs.lagPopover.rel');
        if(lagPopover){
            lagPopover.hoverState = 'in';
            // lagPopover.tip().addClass('in');// TODO: 待测试
        }
    }).on('mouseleave.bs.lagPopover', '.'+LagPopover.HOVER_CLOSE, function (event) {
        var lagPopover = $(this).data('bs.lagPopover.rel');
        if(lagPopover){
            lagPopover.hide();
        }
    });
})();


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/lag-popover.js
// module id = 185
// module chunks = 0